const booleanValidator = {
  $validator: (value) => {
    return [0, 1, "0", "1", true, false, "true", "false"].includes(value);
  },
  // $message: 'test cool'
};

export default booleanValidator;
